import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Enrolled", { props: { triggerType: "Order Submitted", event: "Course purchase" } }],
  ["e1", "auto-email", "Welcome + how to start", { props: { subject: "You're in — start with module 1 (18 min)" } }],
  ["w1", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["c1", "auto-condition", "Watched module 1?", { props: { condition: "Has tag 'module-1-complete'" } }],
  ["e2", "auto-email", "Stuck? Start here", { props: { subject: "The 5-minute version of module 1" } }],
  ["w2", "auto-wait", "Wait 5 days", { props: { duration: "5", unit: "days" } }],
  ["e3", "auto-email", "Module 2 unlocked", { props: { subject: "Module 2 is open — this is the one that clicks" } }],
  ["w3", "auto-wait", "Wait 7 days", { props: { duration: "7", unit: "days" } }],
  ["c2", "auto-condition", "Halfway through?", { props: { condition: "course_progress is greater than 50" } }],
  ["e4", "auto-email", "Certificate + what's next", { props: { subject: "You finished — here's your certificate" } }],
  ["tg", "auto-tag-add", "Tag: course-completer", { props: { tag: "course-completer" } }],
]);

const def: TemplateDef = {
  slug: "course-student-onboarding",
  name: "Course Student Onboarding",
  category: "Coaching",
  tagline:
    "Completion is the real refund policy — nudge the stuck ones before they go quiet.",
  description:
    "A free online course onboarding template: enrolment sends the start-here email, progress branches catch students who never opened module one, and completers get a certificate and the next-program offer. Clone it into FrazzleCRM and let progress events drive the emails.",
  whatsInside: [
    "Enrolment trigger with a start-here email that names one module",
    "Progress branch that re-engages students stuck at module one",
    "Paced module-unlock emails across the first fortnight",
    "Completion tag and certificate email that opens the next offer",
  ],
  flow: makeFlow(
    [
      node("sp", "page-sales", "Course sales page", 40, 60, { props: { price: "$497" } }),
      node("co", "page-checkout", "Checkout", 40, 240, { props: { price: "$497" } }),
      node("mb", "page-members", "Course area", 360, 150, { props: { product: "The course" } }),
      flow("f1", "Student Onboarding", 680, 40, 420, 1132),
      ...seq.nodes,
      node("up", "page-upsell", "Next program", 1200, 340, { props: { price: "$1,500" } }),
      node("out", "outcome-sale", "Continuation sale", 1520, 340, { props: { value: "$1,500" } }),
      node("n1", "util-note", "Refunds track completion", 360, 400, {
        notes:
          "Students who finish module one almost never refund. Everything before the halfway branch exists to get people over that first hurdle — it is a retention flow wearing an onboarding costume.",
      }),
    ],
    [
      edge("sp", "co"),
      edge("co", "mb"),
      edge("mb", "f1"),
      ...seq.edges,
      edge("f1", "up"),
      edge("up", "out"),
    ]
  ),
};

export default def;
